import { classNames } from "helpers/ClassNameHelper";
import React, { useContext } from "react";
import { AccessibilityContext } from "views/AccessibilityContext";

interface Props {
    labelFor: string;
    labelText: string;
    className?: string;
    isValid?: boolean;
    rightIcon?: React.ReactNode;
}

export const InputLabel: React.FC<Props> = ({
    labelFor,
    labelText,
    className,
    isValid = true,
    rightIcon,
}) => {
    const classes = ["label"];
    if (!isValid) classes.push("label--error");
    if (className) classes.push(className);
    const { lowVision } = useContext(AccessibilityContext);
    return (
        <div className="label-container">
            <label
                className={classNames(lowVision ? "low-vision-white-text" : "label")}
                htmlFor={labelFor}
            >
                {labelText}
            </label>
            {rightIcon ? rightIcon : null}
        </div>
    );
};
